import styled from 'styled-components';
import { marginStyle } from '../../const/helpers';
import TextProps from './types';
import { colors } from '../../const/color';
import { font } from '../../const/font';
import { displayHelperStyle } from '../../const/display';

export const TextStyled = styled.h1<TextProps>`
  color: ${({ $color }) => colors[$color]};
  text-align: ${({ $align }) => ($align ? $align : 'inherit')};
  font-size: ${({ $size }) => font.size[$size]}px;
  line-height: ${({ $size }) => font.lineHeight[$size]}px;
  font-weight: ${({ $fontWeight }) => font.weight[$fontWeight]};
  margin: ${({ $m }) => ($m ? `${$m.map(m => marginStyle(m)).join(' ')} !important` : '0')};
  font-family: ${({ $fontFamily }) => ($fontFamily ? font.family[$fontFamily] : font.family.aeonikRegular)}};
  ${({ $display }) => $display && displayHelperStyle($display)}
`;

export default TextStyled;
